
<template>
  <div class="home">
    <Carousel />
    <ImageSection 
      v-if="slide && area_is_show == '1'"
      :imageUrl="slide.image"
      :title="slide.title"
      :content="slide.content"
      :url="slide.articleHref"
      :alt="slide.alt"
      class="img-s"
    />
    <!-- <BaseButton v-if="area_is_show == '1'" text="了解更多" @click="konwmore" /> -->
    <SectionTitle 
      v-if="config && config.title_is_show =='1'"
      id="new_features"
      :mainTitle="config.title"
      :subTitle="config.sub_title"
    />
    <!-- <SectionTitle 
      id="new_features"
      mainTitle="酒吧业态SaaS系统开创者"
      subTitle="探索九点半功能"
    /> -->
    <ImageGrid />
    <BaseButton v-if="config && config.btn_is_show == '1'" :text="config.btn_title" :url="config.btn_href"/>
    <SectionTitle
      v-if="appScenarionConfig && appScenarionConfig.title_is_show == '1'"
      id="application_scenarios" 
      :mainTitle="appScenarionConfig.title"
      :subTitle="appScenarionConfig.sub_title"
    />
    <!-- <SectionTitle
      v-if="appScenarionConfig"
      id="application_scenarios" 
      :mainTitle="appScenarionConfig.title"
      subTitle="使用不同场景"
    /> -->
    <FourCards />
    <BaseButton v-if="appScenarionConfig && appScenarionConfig.btn_is_show == '1'" :text="appScenarionConfig.btn_title" :url="appScenarionConfig.btn_href" class="h-btn-s" />
   
    <MarqueeWithBackground />
    <BrandShowcase />

    <NewsTab />
    <BackgroundBlock />
    <ServiceSection />
  </div>
</template>
<script>
  import TheWelcome from '@/components/TheWelcome.vue'
  import Carousel from '@/components/home/Carousel.vue'
  import ImageSection from '@/components/home/ImageSection.vue'
  import SectionTitle from '@/components/common/SectionTitle.vue'
  import ImageGrid from '@/components/home/ImageGrid.vue'
  import BaseButton from '@/components/common/BaseButton.vue'
  import FourCards from '@/components/home/Fourcards.vue'
  import BrandShowcase from '@/components/home/BrandShowcase.vue'
  import MarqueeWithBackground from '@/components/home/MarqueeWithBackground.vue'
  import NewsTab from '@/components/home/NewsTab.vue'
  import BackgroundBlock from '@/components/home/BackgroundBlock.vue'
  import ServiceSection from '@/components/home/ServiceSection.vue'
  import { homeApi } from '@/api/home'
  import { onMounted } from 'vue';
  import { useRouter } from 'vue-router'
  
  export default {
    name: 'HomeView',
    components: {
      TheWelcome,
      Carousel,
      ImageSection,
      SectionTitle,
      ImageGrid,
      BaseButton,
      FourCards,
      BrandShowcase,
      MarqueeWithBackground,
      NewsTab,
      BackgroundBlock,
      ServiceSection
    },
    data() {
      return {
        slide: null,
        scrollPositions: {} ,
        config: null,
        appScenarionConfig: null,
        router: useRouter(),
        area_is_show: null
      }
    },
    mounted() {
    this.cacheScrollPositions();

    // 监听 hash 变化，用于兼容百度搜索等场景
    this.handleHashChange();
    window.addEventListener('hashchange', this.handleHashChange);

    // iOS 百度浏览器兼容性修复：延迟触发路由检查
    if (/iPhone|iPad|iPod/.test(navigator.userAgent) && /baidu/i.test(navigator.userAgent)) {
      setTimeout(() => {
        this.handleHashChange();
        // 重新检查路由
        const hash = window.location.hash.replace('#', '');
        if (hash && hash !== 'new_features' && hash !== 'application_scenarios') {
          // 如果是其他 hash（如 toRegister），触发路由跳转
          this.$router.push('/' + hash);
        }
      }, 300);
    }
  },
  beforeUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange);
  },
    methods: {
      handleHashChange() {
        const hash = window.location.hash.replace('#', '');
        if (hash === 'new_features' && this.scrollPositions.newFeaturesTop) {
          setTimeout(() => {
            window.scrollTo({ top: this.scrollPositions.newFeaturesTop - 80, behavior: 'smooth' });
          }, 100);
        } else if (hash === 'application_scenarios' && this.scrollPositions.applicationScenariosTop) {
          setTimeout(() => {
            window.scrollTo({ top: this.scrollPositions.applicationScenariosTop - 80, behavior: 'smooth' });
          }, 100);
        }
      },
      konwmore() {
        this.router.push('/toRegister')
      },
      cacheScrollPositions() {
      const newFeaturesElement = document.getElementById('new_features');
      const applicationScenariosElement = document.getElementById('application_scenarios');

      if (newFeaturesElement) {
        const rect = newFeaturesElement.getBoundingClientRect();
        this.scrollPositions.newFeaturesTop = rect.top + window.scrollY;
      }

      if (applicationScenariosElement) {
        const rect = applicationScenariosElement.getBoundingClientRect();
        this.scrollPositions.applicationScenariosTop = rect.top + window.scrollY;
      }

      // 将位置存入缓存（例如，localStorage）
      localStorage.setItem('scrollPositions', JSON.stringify(this.scrollPositions));
    },
      handleClick(href) {
        if (href!='') {
          window.location.href = href
        } else {
          console.log('只做展示'); // 可选：记录警告
        }
      },
      async getFeatureDetailList() {
        try {
          const featureDetail = await homeApi.getFeatureDetailList()
          const item = featureDetail.data.info
          this.area_is_show = featureDetail.data.feature_whole_block_show
          const isMobile = window.innerWidth <= 768
          const image = isMobile ? item.mobile_pic : item.pc_pic
          const alt = isMobile ? item.mobile_pic_alt : item.pc_pic_alt
          const type = isMobile ? item.mobile_pic_type : item.pc_pic_type

          this.slide = {
            image,
            title: item.pic_title,
            content: item.pic_content,
            type,
            articleHref: item.article_href,  // 添加 article_href   
            alt,
          }
        } catch (error) {
          // console.error('FeatureDetail Error:', error)
          this.slide = null
        }
      },
      handleSlideClick(href) {
        if (this.slide) {
          if (this.slide.type === 3) {
            console.log('播放视频:', this.slide.title)
            // 这里可以添加视频播放的具体实现
          } else {
            console.log('跳转到文章:', this.slide.articleHref)
            window.location.href = href
            // window.open(this.slide.articleHref, '_blank')  // 在新标签页中打开链接
          }
        }
      },
      async loadConfig() {
        try {
          const config = await homeApi.getConfigSet();
          const info = config.data
          this.config = {
            title_is_show: info.business_title_show,
            btn_is_show: info.business_guide_btn_show,
            title: info.business_title,
            sub_title: info.business_title_new,
            btn_title: info.business_guide_btn_name,
            btn_href: info.business_guide_btn_href,
            btn_bg: info.business_guide_btn_pic,
          }
        } catch (error) {
          console.error('Failed to load config:', error);
        }
      },
      async loadAppScenarionConfig() {
        try {
          const config = await homeApi.getAppScenarionConfig();
          const info = config.data
          this.appScenarionConfig = {
            title_is_show: info.title_show,
            title: info.title,
            sub_title: info.sub_title,
            btn_is_show:info.guide_btn_show,
            btn_title: info.guide_btn_name,
            btn_href: info.guide_btn_href,
            btn_bg: info.guide_btn_pic,
          }
        
        } catch (error) {
          console.error('Failed to load config:', error);
        }
      }

    },
    mounted() {
      this.getFeatureDetailList()
      this.loadConfig()
      this.loadAppScenarionConfig()
    }
  }
  </script>
<style scoped>
.img-grid-s{
  margin-bottom: 53px;
}
.home {
  background-color: #fff;
}
.img-s,.h-btn-s{
  margin-bottom: 53px;
}
@media screen and (max-width: 768px) {
  .img-s,.h-btn-s{
     margin-bottom: 30px;
   }
}
</style>
